import { DateTimePicker as MuiDateTimePicker, DateTimePickerProps, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon'
import { DateTime } from 'luxon'
import React from 'react'

import { useComplatibleLocale, useRtlLocaleCheck } from '../../hooks'
import { createComponentWrapperWithRef, styled, THEME_CONST, uiTokens } from '../../theme'
import { MsdkStyledComponent } from '../../utils'

interface CustomDateTimePickerProps extends DateTimePickerProps<any> {
  locale?: string
}

const StyledMuiDateTimePicker: MsdkStyledComponent<DateTimePickerProps<any>> = styled(MuiDateTimePicker)`
  .MuiInputBase-root {
    border-radius: ${THEME_CONST.inputBorderRadius}px;
  }
`
const StyledNovaDateTimePicker: MsdkStyledComponent<DateTimePickerProps<any>> = styled(MuiDateTimePicker)`
  .MuiInputBase-root {
    border-radius: ${uiTokens.radius.large}px;
  }
  .MuiSvgIcon-root {
    color: ${uiTokens.uiContent.accent};
  }
  &:hover .MuiInputLabel-root {
    color: ${uiTokens.uiContent.accent};
  }

  .MuiInputLabel-root.Mui-focused {
    color: ${uiTokens.uiContent.accent};
  }
`
export const StyledDateTimePicker = createComponentWrapperWithRef(
  {
    mui: StyledMuiDateTimePicker,
    nova: StyledNovaDateTimePicker,
  },
  'StyledDateTimePicker',
)

export function DateTimePicker(props: CustomDateTimePickerProps) {
  const { locale = DateTime.local().locale, slotProps: slotPropsProp, ...rest } = props
  const compatibleLocale = useComplatibleLocale(locale)
  const isRtl = useRtlLocaleCheck(locale)

  const slotProps = {
    ...slotPropsProp,
    textField: {
      ...slotPropsProp?.textField,
      inputProps: {
        ...(slotPropsProp?.textField as Record<string, any>)?.inputProps,
        dir: isRtl ? 'rtl' : undefined,
      },
    },
  }

  const val = props.value === null || props.value === undefined ? null : props.value

  return (
    <LocalizationProvider dateAdapter={AdapterLuxon} adapterLocale={compatibleLocale}>
      <StyledDateTimePicker {...rest} slotProps={slotProps} value={val} />
    </LocalizationProvider>
  )
}
